import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { subscribeToNewsletter } from "../../firebase/newsletter";
import FirebaseHandler from "../../firebase";
import { httpsCallable } from "firebase/functions";
export var orderFreiexemplar = /*#__PURE__*/ function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee(data, newsletter) {
        var result, _orderResult$data, orderResult;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.prev = 0;
                        if (!newsletter) {
                            _context.next = 4;
                            break;
                        }
                        _context.next = 4;
                        return subscribeToNewsletter(data.email);
                    case 4:
                        _context.next = 6;
                        return httpsCallable(FirebaseHandler.functions, "orderFreiexemplar")(data);
                    case 6:
                        orderResult = _context.sent;
                        result = {
                            // @ts-ignore
                            success: !!((_orderResult$data = orderResult.data) !== null && _orderResult$data !== void 0 && _orderResult$data.success)
                        };
                        _context.next = 14;
                        break;
                    case 10:
                        _context.prev = 10;
                        _context.t0 = _context["catch"](0);
                        console.error(_context.t0);
                        result = {
                            success: false
                        };
                    case 14:
                        return _context.abrupt("return", result);
                    case 15:
                    case "end":
                        return _context.stop();
                }
            }
        }, _callee, null, [[0, 10]]);
    }));
    return function orderFreiexemplar(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();
